import { render, staticRenderFns } from "./organizationsEdit.vue?vue&type=template&id=3aa76c4c&scoped=true&"
import script from "./organizationsEdit.vue?vue&type=script&lang=js&"
export * from "./organizationsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa76c4c",
  null
  
)

export default component.exports